import { useEffect } from 'react';
import styled from 'styled-components';

import multiclock1 from '../../../images/loader/multiclock1.svg';
import multiclock2 from '../../../images/loader/multiclock2.svg';
import multiclock3 from '../../../images/loader/multiclock3.svg';
import multiclock4 from '../../../images/loader/multiclock4.svg';

export const StyledBigLoader = styled.div`
  width: ${({ width }) => width || '120px'};
  height: ${({ height }) => height || '120px'};
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;

  animation: loaderBigAnimation 1s infinite;

  @keyframes loaderBigAnimation {
    0% {
      background-image: url(${multiclock1});
    }
    25% {
      background-image: url(${multiclock2});
    }
    50% {
      background-image: url(${multiclock3});
    }
    75% {
      background-image: url(${multiclock4});
    }
    100% {
      background-image: url(${multiclock1});
    }
  }
`;

export const BigLoader = ({ width, height }) => {
  useEffect(() => {
    const images = [multiclock1, multiclock2, multiclock3, multiclock4];

    images.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return <StyledBigLoader width={width} height={height} />;
};